import styled, { css } from "styled-components";
import PropTypes from "prop-types";

var Table = styled.table.withConfig({
  displayName: "Table",
  componentId: "sc-1d501di-0"
})(["border-spacing:0px;", ";td,th{padding:", ";}", ";", ";"], function (props) {
  return props.fluid && css(["width:100%;"]);
}, function (props) {
  return props.compact ? "0.25em 0" : "0.5em 0";
}, function (props) {
  return props.columns && props.columns.map(function (width, i) {
    return css(["td:nth-child(", "){width:", ";}"], i + 1, width);
  });
}, function (props) {
  return props.bordered && css(["td{border-bottom:1px solid #f4f4f4;}tbody > tr:last-child > td{border-bottom:none;}"]);
});

Table.propTypes = {
  bordered: PropTypes.bool,
  compact: PropTypes.bool
};

export default Table;